import { EVENT_CODES } from '../data/Constants';

export const fpTrack = (eventCode, props = {}) => {
  const code = EVENT_CODES[eventCode];
  console.log('[fpTrack]', eventCode, '->', code, props);
  try {
    window.freshpaint.track(code, {
      timestamp: new Date().toISOString(),
      ...props,
    });
  } catch (e) {
    console.error('Freshpaint tracking error:', e);
  }
};
